/** True when the given date falls on a Saturday or Sunday */
export function isWeekend(date: Date): boolean {
  const day = date.getDay();
  return day === 0 || day === 6;
}

/**
 * Returns `count` business days starting from `from`, inclusive of `from` itself
 * if it is a business day. Weekends are skipped.
 */
export function getUpcomingBusinessDays(count: number, from: Date = new Date()): Date[] {
  const days: Date[] = [];
  const cursor = new Date(from);
  cursor.setHours(0, 0, 0, 0);

  while (days.length < count) {
    if (!isWeekend(cursor)) {
      days.push(new Date(cursor));
    }
    if (days.length < count) {
      cursor.setDate(cursor.getDate() + 1);
    }
  }
  return days;
}

/** The first selectable date once `count` business days (inclusive of `from`) have elapsed */
export function getMinDateAfterBusinessDays(count: number, from: Date = new Date()): Date {
  const days = getUpcomingBusinessDays(count, from);
  const minDate = new Date(days[days.length - 1]);
  minDate.setDate(minDate.getDate() + 1);
  return minDate;
}
